import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { ActivityBadge } from 'components/sections/dashboard'
import { ElevatedBox, Card, InfoIconCaption } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import getTimeFromDuration from 'helpers/getTimeFromDuration'
import { apiDownloadFile } from 'helpers/decorators/api'
import styles from './log-card.styl'

@apiDownloadFile({ withCode: true })
class LogCard extends Component {
  static propTypes = {
    onOpenDetail: PropTypes.func,
    onDownloadFile: PropTypes.func,
    files: PropTypes.object,
    activitySection: PropTypes.string,
    log: PropTypes.object,
    variableHeight: PropTypes.bool
  }

  componentWillMount() {
    this.getDownloadedImage()
  }

  getDownloadedImage = () => {
    const { files, log, onDownloadFile } = this.props
    const url = get(log, 'fileUrls[0]')
    const previewFile = files[url]

    url && !previewFile && onDownloadFile(url)
  }

  handleOpenDetail = () =>
    this.props.onOpenDetail && this.props.onOpenDetail(this.props.log)

  handleRenderPreview = (previewFile = {}) => {
    if (previewFile.type === 'pdf') {
      return (
        <div className={styles.file}>
          <span className="ico ico--file-pdf" />
        </div>
      )
    }
    return (
      <div
        className={styles.img}
        style={{
          backgroundColor: 'white',
          backgroundImage: `url(${get(previewFile, 'fileLocalUrl')})`
        }}
      />
    )
  }

  render() {
    const {
      log,
      activitySection,
      files,
      variableHeight,
      onOpenDetail
    } = this.props


    const comments = get(log, 'praises')
    const commentsCount = comments && comments.length
    const colorClass = getActivityClassName(activitySection)
    const classNames = [styles.item, styles[colorClass], styles.logCardContent]
    const time = getTimeFromDuration(get(log, 'duration'))
    const url = get(log, 'fileUrls[0]')
    const previewFile = files[url]
    const description = get(log, 'description')

    return (
      <div className={classNames.join(' ')}>
        <ElevatedBox
          onClick={this.handleOpenDetail}
          clickable={Boolean(onOpenDetail)}
        >
          <Card.Wrap variableHeight={variableHeight}>
            <Card.Left>
              <div className={styles.badge}>
                {get(previewFile, 'fileLocalUrl') ? (
                  this.handleRenderPreview(previewFile)
                ) : (
                  <ActivityBadge
                    activitySection={activitySection}
                    plain
                    large
                  />
                )}
              </div>
            </Card.Left>

            <Card.Content>
              <Card.Top>
                <Card.Middle>
                  <h3 className={styles.description}>
                    {description.length > 100 ? description.substring(0, 100) + '...' : description}
                  </h3>
                </Card.Middle>
              </Card.Top>
              <Card.Bottom>
                <p className={styles.text}>
                  {get(log, 'date') && (
                    <InfoIconCaption
                      ico="date"
                      caption={
                        <FormattedDate
                          value={log.date}
                          year="numeric"
                          month="numeric"
                          day="numeric"
                        />
                      }
                      colorClass={colorClass}
                    />
                  )}

                  {get(log, 'category') && (
                    <InfoIconCaption
                      ico="filter-hdr"
                      caption={log.category}
                      colorClass={colorClass}
                    />
                  )}

                  {get(log, 'duration') && (
                    <InfoIconCaption
                      ico="time"
                      caption={
                        <FormattedMessage
                          id="dashboard.activity_log_time"
                          defaultMessage="{hours}h {minutes}min"
                          values={time}
                        />
                      }
                      colorClass={colorClass}
                    />
                  )}

                  {commentsCount > 0 && <InfoIconCaption
                    ico="chat"
                    colorClass={colorClass}
                    caption={
                      <FormattedMessage
                        id={commentsCount === 1 ? "dashboard.activity_log_comment" : "dashboard.activity_log_comments"}
                        defaultMessage={commentsCount === 1 ? "{commentsCount} comment" : "{commentsCount} comments"}
                        values={{commentsCount : commentsCount}}
                      />
                    }
                  />}

                </p>
              </Card.Bottom>
            </Card.Content>
          </Card.Wrap>
        </ElevatedBox>
      </div>
    )
  }
}

export default LogCard
